export default __webpack_public_path__ + "static/media/News & Announcements.b27316e4.svg";